import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useConfiguratorContext } from '../../Context/ConfiguratorContext.js';
import { useSteps } from '../../hooks/use-steps.js';
import { StepForm, ConnectedStepForm } from './StepForm.js';

const StepFormContainer = (props)=>{
    const { getLabel  } = useIntl();
    const { configuratorId  } = useConfiguratorContext();
    const { currentStep  } = useSteps();
    const { labelKeys  } = currentStep;
    const labels = React.useMemo(()=>({
            ariaLabel: getLabel(labelKeys.title)
        })
    , [
        getLabel,
        labelKeys.title
    ]);
    return /*#__PURE__*/ React.createElement(StepForm, swcHelpers.extends({}, props, {
        configuratorId: configuratorId,
        "aria-label": labels.ariaLabel
    }));
};
const ConnectedStepFormContainer = (props)=>{
    const { getLabel  } = useIntl();
    const { configuratorId  } = useConfiguratorContext();
    const { currentStep  } = useSteps();
    const { labelKeys  } = currentStep;
    const labels = React.useMemo(()=>({
            ariaLabel: getLabel(labelKeys.title)
        })
    , [
        getLabel,
        labelKeys.title
    ]);
    return /*#__PURE__*/ React.createElement(ConnectedStepForm, swcHelpers.extends({}, props, {
        configuratorId: configuratorId,
        "aria-label": labels.ariaLabel
    }));
};

export { ConnectedStepFormContainer, StepFormContainer };
//# sourceMappingURL=StepFormContainer.js.map
